import React from 'react';
import { TextField, TextFieldProps } from 'mui-rff';
import cc from 'classnames';
import { showErrorOnChange } from 'utils/validation';
import Button from 'ui/Button/Button';

import styles from './InputWithButton.module.css';

type Props = {
  optional?: boolean;
  optionalString?: string;
  disabledButton: boolean;
  onBtnClick: () => void;
  isShowBtn: boolean;
  btnTxt: string;
};

const InputWithButton = ({
  type = 'text',
  variant = 'filled',
  InputProps,
  className,
  optional,
  optionalString,
  onBtnClick,
  disabledButton,
  btnTxt,
  isShowBtn,
  ...props
}: TextFieldProps & Props) => (
  <div className={cc(className, styles.container)}>
    <TextField
      type={type}
      variant={variant}
      InputProps={{
        endAdornment: isShowBtn && (
          <Button type="button" className={styles.generateBtn} onClick={onBtnClick} disabled={disabledButton}>
            {btnTxt}
          </Button>
        ),
        disableUnderline: true,
        ...InputProps,
      }}
      showError={showErrorOnChange}
      className={cc(
        // eslint-disable-next-line css-modules/no-undef-class
        styles.input,
        // eslint-disable-next-line css-modules/no-undef-class
        { [styles.text]: type === 'text' || type === 'tel' },
      )}
      {...props}
    />
    {optional && <span className={styles.optional}>Optional</span>}
    {optionalString && <span className={styles.optional}>{optionalString}</span>}
  </div>
);

export default InputWithButton;
